export const environment = {
  production: true,
  isTest: false,
  apiBaseUrl: "https://api.eprintitsaas.com/public/",
  socketUrl: "wss://wss.eprintitsaas.com",
  socketApiKey: "06f3fb75-f94a-4fa6-b5ed-822411fa1298",
  // redirectBaseUrl: "http://localhost:8100/redirect/",
  msalClientId: "4a0bb465-5cb2-48ea-9650-714486346613",
  redirectBaseUrl: "https://mobile.eprintitsaas.com/redirect/",
  droboxAppKey: "s587mdobda62ebp",
  droboxAppSecret: "50adn1pcgfrw4td",
  boxClientID: "pdvttfrre7rixdhwnzeu7oa8kfm237ck",
  boxClientSecret: "P2mxeooujIwVAbL3mbQL4ugewTo62q7G",
  tier: "standard",
  apiKey: "266268a4-e631-45c6-8c38-2ecfce753794",
  subdomain: "ippl",
  appShellConfig: {
    debug: false,
    networkDelay: 500,
  },
  endpoint: {
    api_domain: "domainInfo",
    api_location: "locate",
  },
  GAPI_CLIENT_ID:
    "976302890078-2b148qrmvh1cvjddlhns8bt38ec1n25r.apps.googleusercontent.com",
  GAPI_CLIENT_ID_IOS: "976302890078-g97ora02oc2ej22cdc4k51g7fgab9kbm.apps.googleusercontent.com",
  GAPI_API_KEY: "AIzaSyACmsOTOfTsh6bMvLSfeH8ixtTqn0ZTGO8",
  GAPI_SECRET: "jRSg8mNkD0vn860ZkAT2pP6Q",
  GAPI_APP_ID: "976302890078",
  monerisSetMode: "prod",
  heartlandBaseURL: "https://pay.realexpayments.com/pay",
  eghlBaseURL: "https://pay.e-ghl.com/IPGSG/Payment.aspx",
  pay88BaseURL: "https://payment.ipay88.com.my/epayment/entry.asp",
  pay88SignatureType: "HMACSHA512",
  authorizeNetURL: "https://accept.authorize.net/payment/payment"
};
